import gql from 'graphql-tag';

export const queryForJobRoles = gql`
  query queryForJobRoles(
    $limit: Int
    $page: Int
    $query: JobRoleDataTableSortOrQuery
    $sort: JobRoleDataTableSortOrQuery
  ) {
    queryForJobRoles(limit: $limit, page: $page, query: $query, sort: $sort) {
      items {
        id
        name
        shiftGroups {
          id
          name
        }
        enabled
        version
      }
      totalRecords
    }
  }
`;
